import React from 'react';

import {Anchor, Button} from '@newsela/angelou';
import {cx} from 'emotion';
import PropTypes from 'prop-types';

import withTrackEvent from 'static/three-oh/src/components/with/WithTrackEvent';

import {ReactComponent as MicrosoftSvg} from '../assets/MicrosoftSSO.svg';
import styles from '../styles';

const propTypes = {
  actionName: PropTypes.string,
  additionalClassName: PropTypes.string,
  anchorText: PropTypes.string.isRequired,
  ariaProps: PropTypes.object,
  href: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  eventProperties: PropTypes.object,
  legacyEventName: PropTypes.string,
  streamProperties: PropTypes.object,
};


const AnchorWithTrackEvent = withTrackEvent(Anchor);

const MicrosoftAnchor = ({
  actionName,
  additionalClassName,
  anchorText,
  ariaProps,
  href,
  iconClassName,
  eventProperties,
  legacyEventName,
  streamProperties,
}) => {
  return (
    <AnchorWithTrackEvent
      href={href}
      additionalClassName={additionalClassName}
      styleAnchorAsButton={{
        flavor: Button.flavor.solid,
        statusColor: Button.statusColor.primary,
        size: Button.size.justified
      }}
      __css={`
        background-color: ${styles.microsoftBrandColor};
        padding-left: 0.3rem;
        &:hover, &:focus {
          background: linear-gradient(0deg, rgba(29, 29, 29, 0.15), rgba(29, 29, 29, 0.15)), ${styles.microsoftBrandColor};
        }
        &[disabled] {
          background-color: ${styles.microsoftBrandColor};
        }
      `}
      ariaProps={ariaProps}
      dataProps={{
        'data-qa-selector': 'microsoft_link',
        id: 'microsoft_link'
      }}
      objectType="User"
      actionName={actionName}
      eventProperties={eventProperties}
      legacyEventName={legacyEventName}
      streamProperties={streamProperties}
    >
      <div className={styles.socialLinkDescription}>
        <MicrosoftSvg
          aria-hidden="true"
          className={cx([styles.microsoftIcon, iconClassName])}
        />
        <span className={styles.linkLabel}>{anchorText}</span>
      </div>
    </AnchorWithTrackEvent>
  );
};

MicrosoftAnchor.propTypes = propTypes;

export default MicrosoftAnchor;
